<google-map class="DashboardDataMap" width="100%" [options]="options">
    <map-marker #markers="mapMarker" width="100%" *ngFor="let marker of User;"
    [position]="{lat:marker.current_lat,lng:marker.current_lon}" [options]="{icon : {
        path: 'm0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z',
        fillColor: 'green',
        fillOpacity: 1.0,
        scale: .5,
        strokeColor: 'green',
        rotation: marker.lastPositionUpdate_heading_spire ? marker.lastPositionUpdate_heading_spire : marker.heading 
    } } "
    (mapClick)="markerClick(markers,$event,marker.imo)">
        <map-info-window>
            <div class="ModelListingData MapModelListingData ">
                <div class="modal-dialog my-0">
                  <div class="modal-content p-0 border-0"> 
                    <div class="modal-body scrollBdymap">
                       <div class="col-left" *ngIf="metaData && metaData.Ship">
                           <span class="common-heading-bold">{{metaData && metaData.Ship ? metaData.Ship : '-'}}</span>
              
                          <div class="journey-track">
                              <div class="journey-track-inner journey-line">
                                <h2 class="common-heading-bold"> <span class="RectanglePoint active">
                                  <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.35355 4.35331C9.12886 -0.421993 16.8711 -0.421993 21.6464 4.35331C26.4217 9.12861 26.4217 16.8709 21.6464 21.6462L13 30.2926L4.35355 21.6462C-0.421751 16.8709 -0.421748 9.12861 4.35355 4.35331Z" fill="white" stroke="#008ECF"/>
                                  </svg> 
                                </span> {{filterData && filterData.stop_port_name ? ((filterData.stop_port_name | titlecase)+', '+(filterData.stop_port_country_code_3 | uppercase)) : '-'}}</h2>
                                <div class="journeyTxt-in">
                                  <span class="Txt-grey StoltSmallTxt spaceTp8">Departed: {{filterData && filterData.previous_port_call_time ? (filterData.previous_port_call_time | date:'d MMM y') : '-'}}</span>
                                  <span class="Txt-grey StoltSmallTxt nextport">AIS reported next port</span>
                                </div> 
                              </div>
                              <div class="journey-track-inner">
                                <h2 class="common-heading-bold"> 
                                  <span class="RectanglePoint">
                                  <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.35355 4.35331C9.12886 -0.421993 16.8711 -0.421993 21.6464 4.35331C26.4217 9.12861 26.4217 16.8709 21.6464 21.6462L13 30.2926L4.35355 21.6462C-0.421751 16.8709 -0.421748 9.12861 4.35355 4.35331Z" fill="white" stroke="#008ECF"/>
                                  </svg> 
                                </span>{{filterData && filterData.destination ? ((filterData.destination | titlecase)+', '+(filterData.destination_country_code_3)) : '-'}}</h2>
                                <div class="journeyTxt-in">
                                </div> 
                              </div>
                          </div>
              
                          <div class="InfoDataOneline">
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Operator</span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.master_operator ? filterData.master_operator : '-'}}</span>
                            </div>
      
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Vessel age</span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.age ? filterData.age : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Tank type </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.tank_type ? filterData.tank_type : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">No of tanks </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.Tanks ? filterData.Tanks : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">DWT </span>
                              <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.DWT ? (filterData.DWT | number) : '-'}}</span>
                            </div>
              
                          </div>
              
              
                          <div class="InfoDataOneline">
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">LOA</span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.LOA ? metaData.LOA : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Beam </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Beam ? metaData.Beam : '-'}}</span>
                            </div>
              
                            <div class="InfoData" *ngIf="trailData">
                              <span class="Txt-grey StoltSmallTxt">Draft (Current)</span>
                              <span class="BoldTxt StoltSmallTxt">
                                {{trailData && trailData.length && trailData[0].draught ? trailData[0].draught : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Draft (@ Summer LL) </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.Draft ? metaData.Draft : '-'}}</span>
                            </div>
              
                            <div class="InfoData">
                              <span class="Txt-grey StoltSmallTxt">Total cubic capacity </span>
                              <span class="BoldTxt StoltSmallTxt">{{metaData && metaData.CBM ? (metaData.CBM | number) : '-'}}</span>
                            </div>
              
                          </div>
              
                       </div>
               
                       <div class="col-left" *ngIf="!metaData || !metaData.Ship">
                        <span class="common-heading-bold Stolt-Skeleton"></span>
                        <div *ngFor="let number of [0,1,2]">
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton"></span>
                            <span class="BoldTxt StoltSmallTxt Stolt-Skeleton"></span>
                          </div> 
                        </div>
              
                        <div class="InfoDataOneline"> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>
              
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                        </div>
              
                        <div class="InfoDataOneline"> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-100"></span> 
                          </div> 
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-75"></span> 
                          </div>  
                          <div class="InfoData">
                            <span class="Txt-grey StoltSmallTxt Stolt-Skeleton w-50"></span> 
                          </div>            
                        </div>  
                       </div>
              
                       <div class="col-right col-right-map" *ngIf="metaData && metaData.Ship && polygonArr.length">
                         <div class="MapCol">
                          <p class="Lastupdatetxt">Last position update: {{last_position_update | timeAgo}}</p>
                          <google-map width="100%" [options]="optionsMap" (idle)="initClusterer($event)">
                            <map-marker-clusterer   [imagePath]="markerClustererImagePath">
                                <ng-container *ngFor='let marker of trailData;;let f = first; let l = last;index as j'>
                                    <map-marker #markers1="mapMarker" width="100%"
                                    [position]="{lat:marker.Latitude,lng:marker.Longitude}"
                                    [options]="{icon : passingPort}" [label]="{color: '#008ECF',
                                    fontFamily: 'Roboto',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    text:marker.stop_port_name|titlecase}">
                                    <map-info-window>{{marker.stop_port_UNlocode ? (marker.stop_port_UNlocode | uppercase) : ''}}, {{marker.stop_port_name ? (marker.stop_port_name | titlecase) : ''}}</map-info-window>
                                    </map-marker>
                                </ng-container>
                            </map-marker-clusterer>

                              <!-- Map Highlights Options -->
                              <div class="HighlightsBox">
                                <div class="HighlightsBoxInner">
                                    <div class="OptionsHld">
                                        <span>Vessel location</span>
                                        <span>
                                          <img src="assets/images/svg/Vessel-location.svg"> 
                                        </span>
                                    </div>
                                    <div class="OptionsHld">
                                        <span>Completed Voyage</span>
                                        <span>
                                          <img src="assets/images/svg/Completed-voyage.svg"> 
                                        </span>
                                    </div>
                                    <!-- <div class="OptionsHld">
                                        <span>Activity Port</span>
                                        <span>
                                          <img src="assets/images/svg/Activity-Port-Port.svg"> 
                                        </span>
                                    </div>  -->
                                    <div class="OptionsHld">
                                      <span>Passing Port</span>
                                      <span>
                                        <img src="assets/images/svg/Passing-Port.svg"> 
                                      </span>
                                    </div>  
                                </div>
                            </div>
                            <!-- Map Highlights Options -->
                              <ng-container>
                                <map-polygon [options]="{editable:false}">
                                    <map-polyline [path]="polygonArr" [options]="{strokeColor:'#008ECF',editable:false}">
                                    </map-polyline>
                                </map-polygon>
                                <ng-container *ngFor='let loc of mapTrail;let f = first; let l = last;index as j'>
                                    <map-marker *ngIf="l" #markers2="mapMarker" [position]="{lat:loc?.latitude,lng:loc?.longitude}" [options]="{icon :currentShipIcon}" (mapClick)="openInfoWindow(markers2,infoWindow)">
                                      <map-info-window class="brandS-label" #infoWindow="mapInfoWindow">{{filterData.Ship|titlecase}}</map-info-window>
                                    </map-marker>
                                </ng-container>
                            </ng-container>
                        </google-map>
                         </div>
              
                         <div class="rightcoldata">
                          <div class="InfoDataOneline spacebtm">
                              <div class="InfoData">
                                <p class="RegionHeadingHld"> 
                                  <span class="BoldTxt StoltSmallTxt RegionHeading">
                                    <em class="MapDot"></em>
                                    {{filterData && filterData.region ? (filterData.region) : '-'}}</span>
                                    <span class="tooltip-holder">
                                      <a href="#">Other probable regions
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8 0.25C3.71875 0.25 0.25 3.75 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.25 15.75 15.75 12.2812 15.75 8C15.75 3.75 12.25 0.25 8 0.25ZM8 3.6875C8.71875 3.6875 9.3125 4.28125 9.3125 5C9.3125 5.75 8.71875 6.3125 8 6.3125C7.25 6.3125 6.6875 5.75 6.6875 5C6.6875 4.28125 7.25 3.6875 8 3.6875ZM9.75 11.625C9.75 11.8438 9.5625 12 9.375 12H6.625C6.40625 12 6.25 11.8438 6.25 11.625V10.875C6.25 10.6875 6.40625 10.5 6.625 10.5H7V8.5H6.625C6.40625 8.5 6.25 8.34375 6.25 8.125V7.375C6.25 7.1875 6.40625 7 6.625 7H8.625C8.8125 7 9 7.1875 9 7.375V10.5H9.375C9.5625 10.5 9.75 10.6875 9.75 10.875V11.625Z" fill="#008ECF"/>
                                        </svg>                             
                                      </a>
                                      <span class="tooltpdropBx" [ngClass]="{TopSideOpen: trailData.length < 4}">
                                        <ul>
                                          <li class="ListHead">
                                            <span class="RegionSpan">Region</span>
                                            <span class="ETA-region">ETA into region</span>
                                            <span>Confidence</span>
                                          </li>
                                          <li class="Listbody" *ngFor="let i of otherRegionProbabilityData">
                                            <span class="RegionSpan">{{i.region}}</span>
                                            <span class="ETA-region">{{i.eta ? (i.eta | date:'d MMM y') : '-'}}</span>
                                            <span>{{i.totalProbability ? i.totalProbability : 0 }}%</span>
                                          </li>
                                        </ul>
                                      </span>
                                  </span>
                                </p>
              
                                <p class="ETAinto">
                                  <small class="Txt-grey justify-content-end">ETA into Region</small>
                                  <span class="BoldTxt StoltSmallTxt">{{filterData && filterData.eta_time ? (filterData.eta_time | date:'d MMM y') : '-'}}</span> 
                                </p>
              
                                <p>
                                  <small class="Txt-grey justify-content-end">Confidence</small>
                                  <span class="BoldTxt StoltSmallTxt text-end percentxt">{{(weekType == 0) ? '--' : (filterData.probability | number : '1.0-0' )+'%'}}</span> 
                                </p>
                                 
                              </div>                
                          </div>
              
                          <div class="InfoDataOneline"> 
                            <div class="InfoData">
                              <p class="ThreeCol">
                                <small class="BoldTxt">Previous ports</small> 
                              </p>
              
                              <p class="ThreeCol">
                                <small class="BoldTxt">Laytime</small>   
                              </p>
              
                              <p class="ThreeCol">
                                <small class="BoldTxt">Draft at departure</small> 
                              </p> 
              
                            </div>
                            
                            <div class="InfoData tableView" *ngFor="let marker of trailData;">
                              <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt">{{marker.stop_port_name ? (marker.stop_port_name | titlecase) : ''}}, {{marker.stop_port_UNlocode ? (marker.stop_port_UNlocode | uppercase) : ''}}</span></p>
                              <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt">{{marker.arrivalTime | date:'d MMM':'UTC' }}-{{marker.departureTime | date:'d MMM':'UTC'}}</span> </p>
                              <p class="ThreeCol"><span class="Txt-grey StoltSmallTxt text-end">{{marker.draught ? marker.draught : 'N/A'}}</span></p>  
                            </div> 
              
                        </div>
              
                         </div>
                       </div>
              
                       <div class="col-right SkeletonRight col-right-map" *ngIf="!metaData || !metaData.Ship || !polygonArr.length">
                        <div class="MapCol Stolt-Skeleton"></div>
              
                        <div class="rightcoldata">
                         <div class="InfoDataOneline spacebtm">
                             <div class="InfoData">
                               <p class="Stolt-Skeleton w-30"> </p> 
                               <p class="Stolt-Skeleton w-30"> </p> 
                               <p class="Stolt-Skeleton w-30"> </p> 
                             </div>                
                         </div>
              
                          <div class="InfoDataOneline">  
                            <div class="InfoData" *ngFor="let number of [0,1,2,3,4,5,6,7,8,9,10,11,12]">
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p>
                              <p class="ThreeCol Stolt-Skeleton w-30"> </p> 
                            </div>  
                          </div> 
                        </div>
                      </div>
              
                    </div> 
                  </div>
                </div>
              </div>
        </map-info-window>
    </map-marker>

</google-map>